const increaseDateByDays = (dayJsDate, days) => {
  return dayJsDate.set('date', dayJsDate.get('date') + days);
};

export default increaseDateByDays;